module.exports = __webpack_public_path__ + "img/worksbot_img19121301.3d626544.jpg";